import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  min-width: 600px;
  max-width: 800px;
`;

export const FileInput = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 10px;
`;

export const FileList = styled.div`
  margin-bottom: 20px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 5px;
  background-color: #f5f5f5;
  border-radius: 3px;
  
  span {
    flex: 1;
    font-size: 14px;
    color: #333;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  gap: 10px;
`;

